module.exports = __webpack_public_path__ + "img/Q.894c1401.png";